import MockButtonPanel from './components/MockButtonPanel.jsx';
import MockExampleMonitor from './components/MockExampleMonitor.jsx';
import MockButtonInjector from './components/MockButtonInjector.jsx';
import EditorPreviewSwaggerUIWrapper from './extensions/editor-preview-swagger-ui/wrap-components/EditorPreviewSwaggerUIWrapper.jsx';
import reducers from './reducers.js';
import * as actions from './actions.js';
import * as selectors from './selectors.js';

/**
 * Plugin that adds a "Use for Mock" button next to Examples dropdown in SwaggerUI preview
 */
const EditorMockButtonPlugin = () => {
  // eslint-disable-next-line no-console
  console.log('EditorMockButtonPlugin initializing');

  // Main plugin configuration
  const plugin = {
    components: {
      MockButtonPanel,
      MockExampleMonitor,
      MockButtonInjector,
    },
    wrapComponents: {
      EditorPreviewSwaggerUI: EditorPreviewSwaggerUIWrapper,
    },
    statePlugins: {
      editorMockButton: {
        actions,
        reducers,
        selectors,
      },
    },
  };

  // Return the plugin directly (not as array for editor plugins)
  return plugin;
};

export default EditorMockButtonPlugin;
